import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_TITLE=='production'?"http://prod.bountech.com/marketprod":"http://uat.bountech.com:8080/market"

function request(options) {

  return axios(options)
    .then(res => {
      return res;
    })
    .catch(error => {
      const {
        response: { data }
      } = error;
      this.$message.error(data.message)
      return Promise.reject(error);
    });
}

export default request;
